/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getActiveOrders} from '../api'

 export const useQueryGetActiveOrders = createReactQueryHook('getActiveOrders', getActiveOrders)
